export const API_ERROR_TYPES = Object.freeze({
  ABORTED: 'ABORTED',
  HTTP_ERROR: 'HTTP_ERROR',
  INVALID_RESPONSE: 'INVALID_RESPONSE',
  NETWORK_ERROR: 'NETWORK_ERROR',
  NOT_FOUND: 'NOT_FOUND',
  SERVER_ERROR: 'SERVER_ERROR',
  UNAUTHORIZED: 'UNAUTHORIZED',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
});

export class ApiError extends Error {
  constructor({
    type,
    message,
    status = null,
    code = null,
    fields = {},
    retryable = false,
    operation = null,
    cause,
  }) {
    super(message);
    this.name = 'ApiError';
    this.type = type;
    this.status = status;
    this.code = code;
    this.fields = fields;
    this.retryable = retryable;
    this.operation = operation;
    this.cause = cause;
  }
}

export const isApiError = (error) => error instanceof ApiError;

export const isNotFoundError = (error) => (
  isApiError(error) && error.type === API_ERROR_TYPES.NOT_FOUND
);

export const isReportableError = (error) => {
  if (!isApiError(error)) return true;

  return [
    API_ERROR_TYPES.INVALID_RESPONSE,
    API_ERROR_TYPES.SERVER_ERROR,
  ].includes(error.type);
};
